import {GeofenceSiteGroupEntity} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {BaseEntitySelect, BaseEntitySelectProps} from "../base-entity-select";

export type BaseGeofenceSiteGroupSelectProps = Omit<
  BaseEntitySelectProps<GeofenceSiteGroupEntity>,
  'nameMapper'
>

export const BaseGeofenceSiteGroupSelect = (props: BaseGeofenceSiteGroupSelectProps) => {
  const {...rest} = props;

  const nameMapper = useCallback((e: GeofenceSiteGroupEntity) => {
    return e.name;
  }, []);

  return <BaseEntitySelect nameMapper={nameMapper} {...rest} />;
};
